if (!customElements.get('card-images')) {
  class CardImages extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.card-images__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.mobileOnly = this.dataset.mobileOnly === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      if (!Number.isFinite(this.items) || this.items <= 0) {
        this.items = 1;
      }

      if (!Number.isFinite(this.tabletItems) || this.tabletItems <= 0) {
        this.tabletItems = 1;
      }

      this.sliderInstance = false;

      this.calcItemMinHeight();

      if (!this.enableSlider && !this.mobileOnly) return;

      if (this.mobileOnly) {
        this.mobileBreakpoint = window.matchMedia('(min-width: 1024px)');
        this.onMobileBreakpointChange = this.handleMobileBreakpoint.bind(this);
        this.handleMobileBreakpoint(this.mobileBreakpoint);

        if (this.mobileBreakpoint.addEventListener) {
          this.mobileBreakpoint.addEventListener('change', this.onMobileBreakpointChange);
        } else {
          this.mobileBreakpoint.addListener(this.onMobileBreakpointChange);
        }

        return;
      }

      this.init();
    }

    init() {
      this.initSlider();
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: this.mobileOnly ? 1.1 : 1,
        spaceBetween: this.mobileOnly ? columnGap.mobile : 0,
        loop: this.mobileOnly ? false : true,
        threshold: 2,
        watchOverflow: true,
      };

      if (this.mobileOnly) {
        sliderOptions.breakpoints = {
          480: {
            slidesPerView: 1.2,
            spaceBetween: columnGap.mobile,
          },
        };
      } else {
        const navigation = {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        };

        if (navigation.nextEl && navigation.prevEl) {
          sliderOptions.navigation = navigation;
        }

        const paginationEl = this.section.querySelector(this.selectors.pagination);
        if (paginationEl) {
          sliderOptions.pagination = {
            el: paginationEl,
            clickable: true,
          };
        }

        sliderOptions.breakpoints = {
          1024: {
            slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
            spaceBetween: columnGap.tabletLarge,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop,
          },
        };
      }

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }

    handleMobileBreakpoint(event) {
      const isDesktop = event.matches;

      if (isDesktop) {
        if (typeof this.sliderInstance === 'object') {
          this.destroySlider();
        }
        return;
      }

      if (typeof this.sliderInstance !== 'object') {
        this.init();
      } else {
        this.sliderInstance.slider.update();
      }
    }

    disconnectedCallback() {
      if (this.mobileOnly && this.mobileBreakpoint && this.onMobileBreakpointChange) {
        if (this.mobileBreakpoint.removeEventListener) {
          this.mobileBreakpoint.removeEventListener('change', this.onMobileBreakpointChange);
        } else {
          this.mobileBreakpoint.removeListener(this.onMobileBreakpointChange);
        }
      }
    }

    /**
     * Make sure overlay content display properly without overlap image.
     */
    calcItemMinHeight() {
      let maxHeight = 0;
      const cardMedias = this.querySelectorAll('.card-media');
      cardMedias &&
        cardMedias.forEach((cardMedia) => {
          const cardContent = cardMedia.querySelector('.card-media__content');
          const cardContentInner = cardContent.querySelector('.card-media__content-wrapper');
          const cardContentPadding = this.getElementPadding(cardContent);
          let itemHeight = cardContentInner.offsetHeight;

          if (cardContentPadding) {
            itemHeight += cardContentPadding.top + cardContentPadding.bottom;
          }

          if (itemHeight > maxHeight) {
            maxHeight = itemHeight;
          }

          cardMedia.style.setProperty('--item-height', itemHeight + 'px');
        });

      this.style.setProperty('--items-height', maxHeight + 'px');
    }

    getElementPadding(element) {
      if (!element) {
        return null;
      }

      const style = window.getComputedStyle(element);
      const paddingTop = parseFloat(style.paddingTop);
      const paddingBottom = parseFloat(style.paddingBottom);

      return {
        top: paddingTop,
        bottom: paddingBottom,
      };
    }
  }
  customElements.define('card-images', CardImages);
}
